import { notifyError, notifySuccess } from "./tostfy";

export const ADMIN_CSV_READY_EVENT = "admin-csv-ready";

const REPORT_TYPES = new Set([
  "admin_expense_report",
  "admin_driver_report",
  "admin_dpr_report",
  "admin_trip_report",
  "admin_driver_salary_report",
]);

const PAYMENT_CSV_TYPES = new Set([
  "admin_payment_history",
  "admin_payment_history_csv",
  "admin_payment_csv",
]);

const DRIVER_LEDGER_CSV_TYPES = new Set([
  "admin_driver_ledger",
  "admin_driver_ledger_csv",
]);

const FUEL_SETTLEMENT_CSV_TYPES = new Set([
  "admin_fuel_settlement",
  "admin_fuel_settlement_csv",
]);

export function parseSocketPayload(raw) {
  if (!raw) return {};
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch {
      return { raw };
    }
  }
  return raw;
}

/** API status: 0 = Pending, 1 = Complete, 2 = Failed */
export function resolveCsvStatusLabel(status, csvLink = "") {
  const code = Number(status);
  if (code === 2) return "Failed";
  if (code === 1) return "Complete";
  if (code === 0) return "Pending";
  if (csvLink) return "Complete";
  return "Pending";
}

export function formatCsvReportName(payload) {
  const locationSuffix = payload?.mipl_location_name
    ? ` (${payload.mipl_location_name})`
    : "";
  const name =
    payload?.sheet_title ||
    payload?.file_name ||
    formatCsvTypeLabel(payload?.type);
  return `${name}${locationSuffix}`;
}

export function formatCsvTypeLabel(type) {
  if (!type) return "CSV Report";
  return String(type)
    .replace(/^admin_/, "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function isReportCsvType(type) {
  return REPORT_TYPES.has(type);
}

export function isPaymentCsvType(type) {
  if (!type) return false;
  if (PAYMENT_CSV_TYPES.has(type)) return true;
  return String(type).toLowerCase().includes("payment");
}

export function isDriverLedgerCsvType(type) {
  if (!type) return false;
  if (DRIVER_LEDGER_CSV_TYPES.has(type)) return true;
  return String(type).toLowerCase().includes("ledger");
}

export function isFuelSettlementCsvType(type) {
  if (!type) return false;
  if (FUEL_SETTLEMENT_CSV_TYPES.has(type)) return true;
  const t = String(type).toLowerCase();
  return t.includes("fuel") && t.includes("settlement");
}

export function dispatchAdminCsvReady(payload) {
  window.dispatchEvent(
    new CustomEvent(ADMIN_CSV_READY_EVENT, { detail: payload })
  );
}

export function handleAdminCsvReady(payload) {
  const status = Number(payload?.status);
  const reportName = formatCsvReportName(payload);

  if (status === 1) {
    notifySuccess(`CSV is Generated ${reportName}`);
    return;
  }
  if (status === 2) {
    notifyError(`${reportName} CSV export failed.`);
    return;
  }
}

export function patchReportLogRow(row, payload) {
  const link = payload?.csv_link || row.downloadUrl || "";
  const fileName = payload?.file_name || row.fileName;
  const status = resolveCsvStatusLabel(payload?.status, link);

  return {
    ...row,
    id: payload?.csv_log_id || row.id,
    fileName,
    location: payload?.mipl_location_name || row.location,
    status,
    downloadUrl: link,
    rawType: payload?.type || row.rawType,
    reportType: payload?.sheet_title || row.reportType,
  };
}

export function patchSalaryCsvLogRow(row, payload) {
  const link = payload?.csv_link || row.downloadUrl || "";
  const fileName = payload?.file_name || row.fileName;

  return {
    ...row,
    id: payload?.csv_log_id || row.id,
    fileName,
    status: resolveCsvStatusLabel(payload?.status, link),
    downloadUrl: link,
  };
}
